<app-login-content-container>
  <h2 style="font-weight: 700; font-size: 1.5em; text-align: center">
    {{ "app_selection.select_app_msg" | translate }}
  </h2>

  <div class="d-none mt-5 d-md-flex justify-content-around">

    <div class="app_selection_container">
      <p>{{'app_selection.admin_site_desc' | translate}}</p>
      <uw-button
        [isMediumSize]="true"
        (buttonClick)="navigateToAdminSite()"
        btnLabel="{{ 'app_selection.admin_site' | translate }}"
      ></uw-button>
    </div>

    <div class="app_selection_container">
      <p> {{'app_selection.donor_site_desc' | translate}} </p>
      <uw-button
        [setInitialFocus]="true"
        [isMediumSize]="true"
        (buttonClick)="navigateToDonationSite()"
        btnLabel="{{ 'app_selection.donation_site' | translate }}"
      ></uw-button>
    </div>
  </div>

  <div class="d-flex flex-column d-md-none justify-content-around">

    <div class="app_selection_container">
      <p>{{'app_selection.admin_site_desc' | translate}}</p>
      <uw-button
        [setInitialFocus]="true"
        [isMediumSize]="true"
        (buttonClick)="navigateToAdminSite()"
        btnLabel="{{ 'app_selection.admin_site' | translate }}"
      ></uw-button>
    </div>

    <div class="app_selection_container">
      <p> {{'app_selection.donor_site_desc' | translate}} </p>
      <uw-button
        [isMediumSize]="true"
        (buttonClick)="navigateToDonationSite()"
        btnLabel="{{ 'app_selection.donation_site' | translate }}"
      ></uw-button>
    </div>
  </div>

  <uw-language-selector></uw-language-selector>

</app-login-content-container>